// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bem_a bhy_rj bhy_rk bhy_vh bhy_eb bhy_vf bhy_gs bhy_kh"};